// src/pages/Verify.js
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Verify = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const sessionId = query.get("session_id");

    if (!sessionId) {
      navigate("/subscribe", { replace: true });
      return;
    }

    const verifySession = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/stripe/verify?session_id=${sessionId}`
        );

        if (res.ok) {
          // ✅ Payment verified and user granted access — go directly to dashboard
          navigate("/dashboard", { replace: true });
        } else {
          // ❌ Verification failed
          navigate("/subscribe", { replace: true });
        }
      } catch (err) {
        console.error("Verify error:", err);
        navigate("/subscribe", { replace: true });
      }
    };

    verifySession();
  }, [location.search, navigate]);

  return (
    <div className="h-screen flex items-center justify-center text-lg font-medium">
      Processing your subscription... 🔄
    </div>
  );
};

export default Verify;